export var isAdmin = function () {
    var bodyAdmin = document.querySelectorAll("body.wp-admin");
    return Boolean(bodyAdmin.length);
};
export var forAllCallback = function (selector, callback) {
    var els = document.querySelectorAll(selector);
    if (els.length) {
        els.forEach(function (el) { return callback(el); });
    }
};
export var onAllClick = function (selector, handler) {
    forAllCallback(selector, function (el) {
        el.addEventListener("click", handler);
    });
};
export var getHeaderHeight = function () {
    try {
        var headers = document.querySelectorAll("header");
        var headerHeight_1 = 0;
        headers.forEach(function (header) { return headerHeight_1 += header.offsetHeight; });
        var wpMenuBar = document.getElementById("wpadminbar");
        var wpMenuBarHeight = wpMenuBar ? wpMenuBar.offsetHeight : 0;
        return headerHeight_1 + wpMenuBarHeight;
    }
    catch (e) { }
    return 0;
};
export var scrollToElement = function (el) {
    try {
        var headerHeight = getHeaderHeight();
        var elementPosition = el.offsetTop;
        var offsetPosition = elementPosition - headerHeight;
        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth",
        });
    }
    catch (e) { }
};
export var acfOnRender = function (callback, block) {
    if (block === void 0) { block = ''; }
    try {
        if (window.acf) {
            var type = typeof block !== "undefined" ? "/type=" + block : "";
            console.log("type", type);
            window.acf.addAction("render_block_preview" + type, callback);
        }
    }
    catch (e) {
        console.log("acfOnRender", e);
    }
};
export var throttle = function (callback, limit) {
    var wait = false; // Initially, we're not waiting
    return function () {
        // We return a throttled function
        if (!wait) {
            // If we're not waiting
            callback.call(); // Execute users function
            wait = true; // Prevent future invocations
            setTimeout(function () {
                // After a period of time
                wait = false; // And allow future invocations
            }, limit);
        }
    };
};
// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
export var debounce = function (func, wait, immediate) {
    var timeout = 0;
    return function () {
        var _this = this;
        var args = arguments;
        var later = function () {
            timeout = 0;
            if (!immediate) {
                // @ts-ignore: silly issue with this, and I don't want to disable strict
                func.apply(_this, args);
            }
        };
        var callNow = immediate && !timeout;
        window.clearTimeout(timeout);
        timeout = window.setTimeout(later, wait);
        if (callNow) {
            // @ts-ignore: silly issue with this, and I don't want to disable strict
            func.apply(this, args);
        }
    };
};
